/* ==========================================================================
   Admin Account Page (PORTAL-187)
   The signed-in pharmacy user's own security settings. Open to every role —
   Portal Settings is managers-only, so Staff could not reach 2FA there.
   ========================================================================== */

import { useMemo } from 'react'
import { TwoFactorSettingsCard } from '@/components/auth/TwoFactorSettingsCard'
import { useAdminAuth } from '@/hooks/useAdminAuth'
import {
  getAdminTwoFactorStatus,
  startAdminTwoFactorSetup,
  enableAdminTwoFactor,
  disableAdminTwoFactor,
} from '@/api/admin'

export function Account() {
  const { user } = useAdminAuth()
  const email = user?.email ?? ''

  // Memoized so the card does not refetch its status on every render.
  const twoFactorApi = useMemo(
    () => ({
      getStatus: getAdminTwoFactorStatus,
      startSetup: startAdminTwoFactorSetup,
      enable: enableAdminTwoFactor,
      disable: (code: string) => disableAdminTwoFactor(code, email),
    }),
    [email]
  )

  return (
    <div className="p-6 sm:p-8 max-w-4xl">
      <h1 className="text-2xl font-serif text-charcoal mb-1">My Account</h1>
      <p className="text-sm text-charcoal/70 mb-6">{email}</p>
      <TwoFactorSettingsCard api={twoFactorApi} />
    </div>
  )
}

export default Account
